import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { EmploymentService } from 'app/employment/employment.service';
import { EventBusService } from 'framework/eventbus.service';
import { LocalStorageService } from 'framework/localstorage.service';
import * as ACTIONS_INTERFACE from '../../../actions';
import { EmploymentConfig } from 'app/employment/employment.config';

declare var $: any;

@Component({
  selector: 'additional-education-knockout',
  templateUrl: './additional-education-knockout.component.html',
  styleUrls: ['./additional-education-knockout.component.css']
})
export class AdditionalEducationKnockoutComponent implements OnInit {
  static STAGE_ID: string;
  static STEP_ID: string = 'additional-education-step-v1';
  static STEP_INDEX: number = 0;
  public SUB_STEP_ID: string;
  public SUB_STEP_INDEX: number;
  PARENT_STAGE_STEP_CONFIG: Object;
  
  firstName: string = '';
  scopeYears: number = 0;
  employmentDataConfig; 
  currentStatus: string = 'VISITED';
  isAdditionalEducationAgreed: boolean = false;
  payLoad: Object;
  startTime: any;
  isKnockoutSelected: boolean = false;

  @Input('group')
    public additionalEducationSubForm: FormGroup;
  @Input() configOptions: any;
  @Input() row: any;

  @Output() onSaveExit = new EventEmitter<any>();
  @Output() onAdditionalEducationKnockout = new EventEmitter<any>();
    
  constructor(private _employmentService: EmploymentService,
              private _localStorage: LocalStorageService,
              public _eventBus: EventBusService,
              private _store: Store<ACTIONS_INTERFACE.AppState>) {
    this.startTime = new Date().getTime();
  }

  ngOnInit() {
    this.employmentDataConfig = this._employmentService.employmentDataConfig;
    this.firstName = this._localStorage.getItem('first_name');
    this.scopeYears = this._employmentService.getMinimumScopeInMonths('YEARS') || 0;
    
    this.processConfig();

    if (this._employmentService.getAdditionalEducationServerData().length > 0) {
      this.isKnockoutSelected = true;
      this.isAdditionalEducationAgreed = true;
    } else {
      this.isKnockoutSelected = false;
      this.isAdditionalEducationAgreed = false;
    }
  }
  
  isKnockoutEnabled() {
    $('#radioYes_0').prop('checked', true).trigger('change');
  } 

  private processConfig(): void {
    this.PARENT_STAGE_STEP_CONFIG = this.configOptions['PARENT_CONFIG'];
    this.SUB_STEP_ID = EmploymentConfig.additionalEducationSubStepIndexMapping['knockout']['subStep'];
    this.SUB_STEP_INDEX = EmploymentConfig.additionalEducationSubStepIndexMapping['knockout']['subStepIndex'];

    this.setState();
  }
  
  private setState(): void {
    this.payLoad = {
      name: this.PARENT_STAGE_STEP_CONFIG['STAGE_ID'],
      step: AdditionalEducationKnockoutComponent.STEP_ID,
      stepIndex: AdditionalEducationKnockoutComponent.STEP_INDEX,
      subStep: this.SUB_STEP_ID,
      subStepIndex: this.SUB_STEP_INDEX,
      iteration: null,
      status: this.currentStatus,
      dbRecordPresent: this.PARENT_STAGE_STEP_CONFIG['IS_DB_RECORD_PRESENT']
    };

    this._store.dispatch({ type: this.currentStatus, payload: this.payLoad });
  }
  
  setRadio(inputValue) {
    this.isKnockoutSelected = true;
    
    if (inputValue === 'Yes') {
      this.isAdditionalEducationAgreed = true;
    } else {
      this.isAdditionalEducationAgreed = false;
    }
  }
    
  onNextClick(): void {
    $('#empWaitModal').modal('show');
    
    let obj: Object = {};
    
    if (this.currentStatus === 'VISITED') {
      this.currentStatus = 'COMPLETED'
    }
    
    this.setState();
    
    obj['COMPONENT_STATE'] = this.payLoad;
    obj['startTime'] = this.startTime;

    let indexDetail: Object = {};
    indexDetail['row'] = this.row;
    obj['indexDetail'] = indexDetail;
    obj['isAdditionalEducationAgreed'] = this.isAdditionalEducationAgreed;
    
    this.onAdditionalEducationKnockout.emit(obj);
  }
  
  saveExit() {
    this.onSaveExit.emit();
  }
}
